export const isTestEnv = (typeof jest == "undefined") ? false : true;
